// src/services/network/friendshipApi.ts
import baseApi from '../../lib/baseApi';


// Friendship APIs --------------------------------------------------------------------------
// Search for users
export const searchUsersApi = async (query: string, page = 1) => {
  const response = await baseApi.get(`/profiles/friendships/search-users?q=${query}&page=${page}`);
  return response.data;
};


// Fetch sent friend requests ----------------------------------------------------------------
export const fetchSentRequestsApi = async () => {
  const response = await baseApi.get('/profiles/friendships/sent-requests/');
  return response.data;
};

// Fetch received friend requests ------------------------------------------------------------
export const fetchReceivedRequestsApi = async () => {
  const response = await baseApi.get('/profiles/friendships/received-requests/');
  return response.data;
};

// Fetch list of friends ---------------------------------------------------------------------
export interface FriendsListParams {
  random?: boolean;
  daily?: boolean;
  limit?: number;
  seed?: string;
  cacheBuster?: number;
}

export const fetchFriendsListApi = async (params: FriendsListParams = {}) => {
  const qs = new URLSearchParams();

  // Only set random if explicitly provided
  if (typeof params.random !== "undefined") {
    qs.set("random", params.random ? "1" : "0");
  }

  if (params.daily) qs.set("daily", "1");
  if (typeof params.limit === "number") qs.set("limit", String(params.limit));
  if (params.seed) qs.set("seed", params.seed);
  if (typeof params.cacheBuster === "number") qs.set("cb", String(params.cacheBuster));

  const url = "/profiles/friendships/friends-list/" + (qs.toString() ? `?${qs.toString()}` : "");
  const response = await baseApi.get(url);
  return response.data;
};

// Fetch friend suggestions for Friends tab --------------------------------------------------
export const fetchFriendsSuggestionsApi = async (limit: number) => {
  const response = await baseApi.get(`/profiles/friendships/friends-suggestions/?limit=${limit}`);
  return response.data;
};

// Fetch friend suggestions for Requests tab ------------------------------------------------
export const fetchRequestsSuggestionsApi = async (limit: number) => {
  const response = await baseApi.get(`/profiles/friendships/requests-suggestions/?limit=${limit}`);
  return response.data;
};

// Fetch people suggestions for Square People -----------------------------------------------
export const fetchPeopleSuggestionsApi = async (page = 1) => {
  const response = await baseApi.get(
    `/profiles/friendships/people-suggestions/?page=${page}`
  );
  return response.data;
};

// Send a friend request --------------------------------------------------------------------
export const sendFriendRequestApi = async (toUserId: number) => {
  const response = await baseApi.post('/profiles/friendships/', { to_user_id: toUserId });
  return response.data;
};

// Accept a friend request ------------------------------------------------------------------
export const acceptFriendRequestApi = async (friendshipId: number) => {
  const response = await baseApi.post(`/profiles/friendships/${friendshipId}/accept-friend-request/`);
  return response.data;
};

// Decline a friend request -----------------------------------------------------------------
export const declineFriendRequestApi = async (friendshipId: number) => {
  const response = await baseApi.post(`/profiles/friendships/${friendshipId}/decline-friend-request/`);
  return response.data;
};

// Cancel a friend request ------------------------------------------------------------------
export const cancelFriendRequestApi = async (friendshipId: number) => {
  const response = await baseApi.delete(`/profiles/friendships/${friendshipId}/cancel-request/`);
  return response.data;
};

// // Delete a friendship --------------------------------------------------------------------
export const deleteFriendshipApi = async (friendshipId: number) => {
  const response = await baseApi.post('/profiles/friendships/delete-friendships/', {
    friendshipId,
  });
  return response.data;
};

